/**
 * @description: 
 * @param {type} 
 * @return: 
 */
import { Toast } from 'mint-ui'
import * as auth from '@/assets/configs/api/auth'
 
import * as $ajax from '@/utils/ajax.js'
import router from '@/router'
const state = {
  userId: localStorage.getItem('userId'),
  authorization: localStorage.getItem('authorization'),
  customerPwd: null,
  mobile: null,
  //默认是验证码登录需要  如果是需要密码登录 改成取反即可
  loginType: false,
  //验证码倒计时
  waitTime: 60,
  //用户输入的验证码
  smsCode: null,
  //验证用户手机号码是否符合 类型bool
  is_mobile: false,
  //根据域名前缀判断 发送给用户验证码信息以及登录时候需要的参数 :默认是百驿物联 
  smsAuth: window.location.href.includes('wywl') ? '我要56' : '百驿物联',
  //存储回调地址 微信回调会覆盖
  redirect:localStorage.getItem('redirect'),
  reset:{
    newpaswd :null,
    conpaswd:null,
    info:{}
  }
}



const actions = {

  /**
   * @description [description=>用户事件触发登录方法]
   * @description:[登录成功分发到signInSuccessCalback进行处理]
   * @description:[登录失败分发到signInFailCalback进行处理]
   * @param {context , redirect=>登录成功后需要重定向的路由} 
   * @return: null
   */
  signIn(context, redirect) {
    let { customerPwd, mobile, smsCode, smsAuth, loginType } = context.state
    //如果是密码登录需要对密码进行加密处理
    // context.commit('encrypted', customerPwd);
    $ajax.post(auth.SIGNIN, { customerPwd, mobile, smsCode, smsAuth, loginType: loginType ? 1 : 2 }, 
      success => {
      //分发到mutations->signInSuccessCalback()进行处理
      context.commit('signInSuccessCalback', { redirect, success })
    }, error => {

      Toast(error)
      //分发到mutations->signInFailCalback()进行处理
      context.commit('signInFailCalback', { error })

    })
  },
  /**
   * @description: [用户操作触发手机验证码]
   * @param {type context 随机生成验证码 两分钟内有效期} 
   * @return: null
   */
  randomCode(context) {
    context.commit('checkMobile')
    // context.commit('checkPwdCode')
    if (!state.is_mobile) {
      //后期需要做成全局控件
      Toast("您输入的手机号码格式错误");
    } else {
      //重置倒计时
      context.state.waitTime = 60
      $ajax.get(auth.RANDOMCODE, { mobile: context.state.mobile, smsAuth: context.state.smsAuth }, success => {
        Toast("您的验证码已发送至手机，请注意查收")
        let timer = setInterval(() => {
          //时间只能大于0 小于零不做任何操作
          context.state.waitTime >= 0 && context.state.waitTime--
          //当时间等于0时清除定时器
          !context.state.waitTime && clearInterval(timer)
        }, 1000)
      }, error => {
        Toast(`${error}`)
      })
    }
  },

  /**
   * @description: 微信授权登录 redirect
   * @description: 登录成功后分发到mutations=>signInSuccessCalback进行处理
   * @description: 登录失败分发到mutations=>signInFailCalback进行处理
   * @param {type redirect 登录成功后重定向返回} 
   * @return: 
   */
  wechatSignIn(context, {redirect,openId}) {
     
    // alert(openId)
    // //如果没获取到openId 需要重新回调
    // if(!openId){
      
    //   //微信回调地址写在@assets/api/weChat.js
    //   
    //   window.location.href = wechat.weChatLink
    // }else{
      
      

      $ajax.get(auth.GETAUTHBYOPENID,{openId},success=>{
    
        
        context.commit('signInSuccessCalback',{redirect,success})
      },error=>{
       
        context.commit('signInFailCalback',{redirect,error})
        
      });
     

    
  },
 
 
  /**
   * @description: 失去焦点进行判断两次密码的情况
   * @description: 用户提交时也需要做一次校验
   * @param {type context} 
   * @return: 
   */
  blurCheckNewPwdConPwd(context){
    context.commit('checkConpaswdNewPaswd')
    !state.reset.info.status && Toast(state.reset.info.msg)
    return state.reset.info.status
  },
  /**
   * @description: 用户更新密码
   * @description: 更新成功后用新密码进行登录
   * @description: 调用signIn方法
   * @param {type context} 
   * @return: 
   */
  rebuilPwd(context,redirect){
     //调用异步方法 blurCheckNewPwdConPwd() 返回re是bool值 
     context.dispatch('blurCheckNewPwdConPwd').then(re=>{
       //检验通过后才能提交给后台
      if (re) {
        let newpaswd = state.reset.newpaswd
        //对密码进行加密操作
        const KEY = CryptoJS.enc.Utf8.parse("884b2fbc1397c37a4f6fe951aa19679d");
        const SRCS = CryptoJS.enc.Utf8.parse(newpaswd);
        const ENCRYPTED = CryptoJS.AES.encrypt(SRCS, KEY, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        newpaswd = ENCRYPTED.toString();
        $ajax.post(auth.FORGETPWD,{
          newpaswd,
          type: 0,
          smsCode:state.smsCode,
          mobile:state.mobile
        },
        success=>{
          //修改成功去到登录页面 密码保存 状态改成密码登录
          state.loginType = true
          router.push({
            name:'SignIn',
            query:{redirect}
          })
        },
        error=>{
          Toast(error)
        })
      }
     })
  }
}

const mutations = {
  
  /**
   * @description: 切换密码和验证码的一些操作
   * @description: 需要清空密码或者验证码
   * @param {type} 
   * @return: 
   */
  checkPwdCode(state) {
    state.loginType = false
    //都需要制空
    state.customerPwd = null
    state.smsCode = null,
    state.waitTime = 60,
    state.mobile = null
  },
  /**
   * @description: 对密码进行加密处理
   * @param {type state params} 
   * @return: null
   */
  encrypted(state) {
    if (!state.customerPwd) return
    const KEY = CryptoJS.enc.Utf8.parse("884b2fbc1397c37a4f6fe951aa19679d");
    const SRCS = CryptoJS.enc.Utf8.parse(state.customerPwd);
    const ENCRYPTED = CryptoJS.AES.encrypt(SRCS, KEY, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    state.customerPwd = ENCRYPTED.toString();
  },
  /**
   * @description: 用户登录成功后的一系列操作
   * @param {type} 
   * @return: 
   */
  signInSuccessCalback(state, params) {
    let { redirect, success } = params
    //
    sessionStorage.setItem("authorization",success.authorization)
    success.authorization = "Bearer" + " " + success.authorization
    this.state.Authorization = success.authorization
    
    

    //存储其他键和值
    success['userId'] = success.authorization
    
    success['baserole'] = success.role || null
    success['petroleumAccount'] = success.mobile || null
    success['petroleumAuthor'] = success.authorization || null
    success['isAuth'] = success.isAuth || null
    success['payType'] = success.payType || null
    success['shopId']  =  success.shopId || null

     
    for (let key in success) {
      localStorage.setItem(key, success[key])
    }
    //登录完成后的需要替换登录的路由
    //防止用户继续返回再次进入到登录页面
    router.replace({
      path: redirect || '/'
    })
  },
  /**
   * @description: 用户登录失败后的一系列操作
   * @param {type} 
   * @return: 
   */
  signInFailCalback(state,error) {
//  Toast(`${error}`)
  },
  /**
   * @description: 验证手机格式是否正确
   * @param {type} 
   * @return: 
   */
  checkMobile(state) {
    state.is_mobile = /^1[23456789]\d{9}$/.test(state.mobile)
  },
  /**
   * @description: 对用户重置密码进行校验
   * @param {type state.newpaswd state.conpaswd} 
   * @return: bool
   */
  checkConpaswdNewPaswd(state){
    //防止用户不输入信息
    if(!state.reset.conpaswd || !state.reset.newpaswd){
      state.reset.info =  {status:false,msg:'密码不能为空'}
    }else{
      if(!/^[^\s]{6,20}$/.test(state.reset.newpaswd)){
        state.reset.info = {
          status:false,
          msg:'请输入至少6位密码'
        }
      }else{
        let bool = state.reset.conpaswd === state.reset.newpaswd
        state.reset.info = {
          status:bool,
          msg:bool?'':'两次密码不一致'
        }
      }
      
    }
  }
}


export default {
namespaced: true,
state,
actions,
mutations
}
